export default {
  validate: {
    nin_required: 'Fødselsnummer er nødvendig.',
    phone_not_valid: 'Telefonnummeret er ikke gyldig. Godkjente formater: XXXXXXXX, +47XXXXXXXX og utenlandske.',
    name_required: 'Navn er nødvendig.',
    first_name_required: 'Fornavn er nødvendig.',
    last_name_required: 'Etternavn er nødvendig.',
    emoji_not_allowed: 'Emoji er ikke tillatt.',
    email_required: 'E-post er nødvendig.',
    email_not_valid: 'E-postaddressen er ikke gyldig.',
    amount_required: 'Et beløp er nødvendig.',
    only_numbers_allowed: 'Kun tall er tillatt.',
    date_not_valid: 'Datoen er ikke gyldig. Forventet format: YYYY-MM-DD',
    min_amount: 'Minimumbeløpet er {amount} kr.',
  },
  forms: {
    first_name: 'Fornavn',
    last_name: 'Etternavn',
    email: 'E-post',
    phone: 'Telefonnummer',
    didYouMean: 'Mente du',
    btnSign: 'Skriv under',
    btnWait: 'Vent litt...',
    fieldRequired: 'Du må fylle ut feltet.',
    onlyNumbers: 'Kun tall er tillatt.',
    one_time_donation: 'Engangsbidrag',
    monthly_donation: 'Månedlig bidrag',
    recommended: 'Anbefalt',
    amount: 'Beløp',
    otherAmount: 'Annet',
    donate_monthly_with: 'Bidra månedlig med',
    donate_with: 'Bidra med',
    choose_amount_notice: 'Velg et praktisk, men betydelig beløp for deg.',
    error: {
      title: 'En feil har oppstått',
      description: 'Prøv igjen. Om problemet fortsetter kontakt oss på {email}',
    },
    success: {
      title: 'Handling lagret!',
    },
    noEmoji: 'Du kan ikke ha emojis i feltet.',
    privacyNotice: 'Beskyttelse av dine personopplysninger er ekstremt viktig for oss. Du finner mer informasjon om hvordan vi behandler dataene dine i vår',
    privacyNoticeBtnLabel: 'personvernerklæring',
  },
  privacyPolicy: {
    title: 'Personvernerklæring',
    btnLabel: 'Personvernerklæring',
    errorMessages: 'En feil oppstod. Se vår nettside for mer informasjon: {website}',
  },
  salesTerms: {
    title: 'Salgsbetingelser',
    btnLabel: 'Salgsbetingelser',
    errorMessages: 'En feil oppstod. Se vår nettside for mer informasjon: {website}',
  },
  shared: {
    wait: 'Vent litt...',
    animalFriend: 'dyrevenn',
    or: 'eller',
    and: 'og',
    animal_friend: 'dyrevenn',
    opinion: {
      no_buy: 'Kjøper ikke turbokylling',
      reduce: 'Reduserer forbruket',
      own_way: 'Gjør det på sin egen måte',
      none: 'Ingen mening enda',
    },
  },
}
